/* eslint no-console: "off" */
import { createContext, useContext } from 'react';

import { Notification } from 'entities';

export interface NotificationContext {
  notifications: Notification[];

  unreadNotifications: number;

  fetchMoreOldNotifications: () => Promise<void>;

  markNotificationAsRead: (notification: Notification) => Promise<void>;

  registerNewNotifications: (notifications: Notification[]) => void;

  loadingMoreNotifications: boolean;

  noMoreNotifications: boolean;
}

export const notificationContext = createContext<NotificationContext>({} as NotificationContext);

export function useNotification(): NotificationContext {
  const context = useContext(notificationContext);

  if (!context.notifications) {
    throw new Error('useNotifications must be used within the NotificationProvider');
  }

  return context;
}
